import { render } from "./UploadTutorial.vue?vue&type=template&id=a64f3b68"
const script = {}

import "./UploadTutorial.vue?vue&type=style&index=0&id=a64f3b68&lang=css"

import exportComponent from "/home/ubuntu/API-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__